// Il motivo dell'ultimo errore restituito dal server, per mostrarlo al posto
// dei messaggi generici («Si è verificato un errore…»).
// Lo registrano gli intercettori di axios in MyApiClient: ogni richiesta che
// scrive (POST/PUT/PATCH/DELETE) lo azzera, ogni risposta d'errore lo imposta.

let ultimo = null;

// Nomi dei campi come li vede l'operatore, per tradurre gli errori dello schema.
const CAMPI = {
    standard_price: 'prezzo standard',
    member_price: 'prezzo soci',
    federated_price: 'prezzo riservato ai tesserati / soci',
    fitcoin_cashback: 'cashback Fitcoin',
    price: 'prezzo',
    vat_nature: 'natura IVA',
    vat_rate: 'aliquota IVA',
    name: 'nome',
    description: 'descrizione',
    sportType: 'sport',
    coachId: 'maestro',
    venueId: 'impianto',
    startTime: 'ora di inizio',
    endTime: 'ora di fine',
    bookingDate: 'giorno',
    duration: 'durata',
    capacity: 'numero di posti',
};

const TIPI = {
    number: 'un numero',
    integer: 'un numero intero',
    string: 'un testo',
    boolean: 'sì o no',
    array: 'un elenco',
    object: 'un insieme di dati',
};

function nomeCampo(percorso) {
    const chiave = String(percorso).split('/').filter(Boolean).pop() || '';
    return CAMPI[chiave] || chiave.replace(/_/g, ' ');
}

// Traduce in italiano i messaggi tecnici della validazione del server.
export function traduciErrore(testo) {
    if (!testo || typeof testo !== 'string') return testo;
    let m = /^(?:body|querystring|params)\/(\S+) must be (\w+)$/.exec(testo);
    if (m) return `Il campo «${nomeCampo(m[1])}» deve essere ${TIPI[m[2]] || m[2]}.`;
    m = /^(?:body|querystring|params)\/(\S+) must be equal to one of the allowed values$/.exec(testo);
    if (m) return `Il valore del campo «${nomeCampo(m[1])}» non è tra quelli ammessi.`;
    m = /^(?:body|querystring|params)\/(\S+) must NOT have fewer than (\d+) characters$/.exec(testo);
    if (m) return `Il campo «${nomeCampo(m[1])}» deve avere almeno ${m[2]} caratteri.`;
    m = /^(?:body|querystring|params)\/(\S+) must be >= (\S+)$/.exec(testo);
    if (m) return `Il campo «${nomeCampo(m[1])}» deve essere almeno ${m[2]}.`;
    m = /^(?:body|querystring|params) must have required property '([^']+)'$/.exec(testo);
    if (m) return `Manca il campo «${nomeCampo(m[1])}».`;
    return testo;
}

export function registraErroreServer(dettaglio) {
    ultimo = dettaglio ? traduciErrore(String(dettaglio)) : null;
}

export function azzeraErroreServer() {
    ultimo = null;
}

// Il motivo dato dal server, se c'è; altrimenti il testo generico passato.
export function conMotivo(testoGenerico) {
    const motivo = ultimo;
    ultimo = null;
    return motivo || testoGenerico;
}
